/* @flow */
import React from 'react';
import classnames from 'classnames';

export type PictureType = {|
  tag?: string,
  cover?: boolean,
  attr?: Object,
  sources?: Array<{ src: string, src2x: string, media: string }>,
  src?: string,
  src2x?: string,
  width?: number,
  height?: number,
  decorative?: boolean,
  alt?: string,
  lazyload?: boolean,
|};

function srcSetFunc(src?: string, src2x?: string) {
  let set = src;

  if (src && src2x) {
    set = `${src}, ${src2x} 2x`;
  }

  return set;
}

const Picture = ({
  tag,
  cover,
  attr,
  sources,
  src: imageSrc,
  src2x,
  width = 100,
  height = 100,
  decorative,
  alt,
  lazyload,
}: PictureType): React$MixedElement => {
  const Tag = tag || 'picture';

  return (
    <Tag className={classnames('picture', cover && 'picture--cover')} {...attr}>
      {sources &&
        sources.map((source, index) => (
          <source
            key={index}
            srcSet={srcSetFunc(source.src, source.src2x)}
            media={source.media}
          />
        ))}
      <img
        className="picture__image"
        src={
          imageSrc ||
          `https://bildermangel.de/${width}x${height}/cbc6bd/afa697.webp?text=${width}x${height}`
        }
        srcSet={srcSetFunc(imageSrc, src2x)}
        width={width}
        height={height}
        alt={decorative ? '' : alt}
        loading={lazyload ? 'lazy' : 'auto'}
      />
    </Tag>
  );
};

export default Picture;
